var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppButtonIcon',{staticClass:"modal-close-button",attrs:{"effect":"rotate","icon":"far fa-times"},on:{"click":_vm.closeModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }